import { MarketingHubListingBanner } from '@eventbrite/footer-banner';
import React from 'react';

export interface BoostBannerProps {
    eventId: string;
}

const BoostBanner = (props: BoostBannerProps) => {
    return <MarketingHubListingBanner {...props} />;
};

export default BoostBanner;
